import {
  Avatar,
  AvatarFallback,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuTrigger,
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@/components/ui";
import {
  ROLE_BOM,
  ROLE_CAM,
  ROLE_CAM_ACCOUNTANT,
  ROLE_OWNER,
  yearOptions,
} from "@/lib/utils";
import { ChevronDown, MenuIcon } from "lucide-react";
import useHeader from "./useHeader";
import { Sidebar } from "../Sidebar";
import { Dialog, FormLabel, Select } from "@/components";
import camsLogo from "@/assets/camsLogo.png";

const Header = () => {
  const {
    currentFinanceYear,
    onYearChange,
    isOpen,
    onLogoutClick,
    handleClose,
    setIsOpen,
    loggedInUserData,
    isLogoutOpen,
    setIsLogoutOpen,
    onLogout,
    onCommunityChange,
    bomUserCommunities,
    isBomCommunityLoading,
    disabledCommunityDropdown,
    onRoleChange,
    currentRole,
    isRoleMenuOpen,
    setIsRoleMenuOpen,
    communityData,
    communityKey
  } = useHeader();

  return (
    <>
      <header className="bg-white fixed w-full flex items-center px-4 z-50">
        {/* This only for mobile menu */}
        <div className="flex flex-row items-center justify-between">
          <Popover open={isOpen} onOpenChange={setIsOpen}>
            <PopoverTrigger className="lg:hidden" asChild>
              <Button variant="ghost">
                <MenuIcon />
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-full ml-[20px] bg-white p-3 shadow-lg rounded-sm">
              <Sidebar handleClose={handleClose} />
            </PopoverContent>
          </Popover>
          <div className="flex flex-row items-center justify-between">
            <img src={camsLogo} className="w-[300px] md:w-[200px]" />
          </div>
        </div>
        <div className="flex justify-end w-full items-center relative">
          <div className="relative w-65 min-w-65 max-w-65 shrink-0">
            {loggedInUserData?.roles?.includes(ROLE_OWNER) &&
            !isBomCommunityLoading &&
            bomUserCommunities?.data?.length > 1 ? (
              <Select 
                key={communityKey}
                placeholder=""
                searchPlaceholder="Search...."
                noDataPlaceholder="No Data Found"
                options={bomUserCommunities?.data?.sort((a: any, b: any) => Number(b.tncApproved) - Number(a.tncApproved))?.map((data: any) => ({
                  label: data?.communityName,
                  value: data?.communityId?.toString()
                }))}
                value={communityData?.communityId}
                onChange={onCommunityChange}
                disabled={disabledCommunityDropdown}
                className="h-[36px] w-full"
              />
            ) : (
              <></>
            )}
          </div>
          {loggedInUserData?.roles?.includes(ROLE_OWNER) && currentRole == ROLE_OWNER && (
            <div className="relative ml-3 w-[90px] shrink-0">
              <FormLabel>Year</FormLabel>
              <Select
                showSearch={false}
                options={yearOptions(5)?.map((d: any) => ({
                  value: d.value?.toString(),
                  label: d.label,
                }))}
                value={currentFinanceYear}
                onChange={onYearChange}
                className="h-[36px] w-full"
              />
            </div>
          )}
          <Button type="button" onClick={onLogoutClick} className="ml-3">Logout</Button>
          {/* For Profile Menu */}
          <div className="flex flex-row items-center justify-between border-l-1 border-g-200 py-2 px-3 ml-3 w-[120px] md:w-[130px]">
            <Avatar className="h-[40px] w-[40px]">
              {/* <AvatarImage
                src="https://github.com/shadcn.png"
                alt="@shadcn"
              /> */}
              <AvatarFallback className="bg-primary text-white">{`${loggedInUserData?.fullName
                ?.split(" ")?.[0]
                ?.charAt(0)
                ?.toUpperCase()}${loggedInUserData?.fullName
                ?.split(" ")?.[1]
                ?.charAt(0)
                ?.toUpperCase()}`}</AvatarFallback>
            </Avatar>
            <div className="flex flex-col item-center justify-center">
              <span className="text-[12px] text-g-500 text">
                {loggedInUserData?.fullName?.split(" ")?.[0] || ""}
              </span>
              {communityData?.bom &&
              loggedInUserData?.roles?.includes(ROLE_BOM) ? (
                <DropdownMenu
                  open={isRoleMenuOpen}
                  onOpenChange={setIsRoleMenuOpen}
                >
                  <DropdownMenuTrigger className="text-[12px] text-g-300 flex flex-row items-center gap-1 cursor-pointer">
                    {currentRole == ROLE_BOM ? "BM" : "Owner"}{" "}
                    <ChevronDown className="h-4 w-4" />
                  </DropdownMenuTrigger>
                  <DropdownMenuContent className="p-3">
                    <DropdownMenuLabel
                      className="text-[12px] p-2 cursor-pointer text-primary hover:bg-blue-50 hover:text-primary"
                      onClick={onRoleChange}
                    >
                      Switch to {currentRole == ROLE_BOM ? "Owner" : "BM"}
                    </DropdownMenuLabel>
                  </DropdownMenuContent>
                </DropdownMenu>
              ) : (
                <span className="text-[12px] text-g-300">
                  {loggedInUserData?.roles?.includes(ROLE_CAM) ||
                  loggedInUserData?.roles?.includes(ROLE_CAM_ACCOUNTANT)
                    ? loggedInUserData?.communityRoles?.find(
                        (data: any) =>
                          data?.communityId == communityData?.communityId
                      )?.role == ROLE_CAM
                      ? "CAM"
                      : "CAM-A"
                    : loggedInUserData?.roles?.includes(ROLE_OWNER)
                    ? "Owner"
                    : "Admin"}
                </span>
              )}
            </div>
          </div>
        </div>
      </header>
      {isLogoutOpen && (
        <Dialog
          open={isLogoutOpen}
          setOpen={setIsLogoutOpen}
          title={<h2 className="text-2xl font-bold">Logout</h2>}
          onSave={onLogout}
          saveText="Logout"
        >
          <div className="flex flex-col gap-4">
            <p>Are you sure you want to logout?</p>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default Header;
